import React from 'react';

import './Avatar.css';

class Avatar extends React.Component {
    
    state = {
        error: false
    };

    onError = () => {

        return this.setState({ error: true });
    };
    
    render() {
        
        const { image, children } = this.props;
        const ok = image && !this.state.error;
        
        return (
            <div className="avatar">
                <div className="image" style={ ok ? { background: 'transparent' } : null }>
                    { ok ? (<img src={image} onError={this.onError} />) : (<span className="icon-person" />) }
                </div>
                { children }
            </div>
        );
    }
}

export default Avatar;


// WEBPACK FOOTER //
// ./src/components/Avatar.jsx